import { render } from "./composeWhatsapp.vue?vue&type=template&id=fc430b2e&scoped=true"
import script from "./composeWhatsapp.vue?vue&type=script&lang=js"
export * from "./composeWhatsapp.vue?vue&type=script&lang=js"

import "./composeWhatsapp.vue?vue&type=style&index=0&id=fc430b2e&scoped=true&lang=css"
import "./composeWhatsapp.vue?vue&type=style&index=1&id=fc430b2e&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc430b2e"]])

export default __exports__